/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
// import actions from './actions'
// import getters from './getters'
import modules from './modules'
// import mutations from './mutations'
// import state from './state

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  modules,

  state: {
    token: localStorage.getItem('access_token') || null,
    status: '',
  },

  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },

    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = ''
    },
  },

  actions: {

    login(context, payload) {

      return new Promise((resolve, reject) => {

        axios.post('/login', payload)
          .then((response) => {
            let accessToken = response.data.access_token;

            context.commit('authSuccess', accessToken)

            localStorage.setItem('access_token', accessToken);

            resolve(response);

          })
          .catch((error) => {
            localStorage.removeItem('access_token');
            context.commit('authError')
            console.log(error);
            reject(error);
          })

      })

    },

    logout(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

      if (context.getters.isAuthenticated) {
        return new Promise((resolve, reject) => {
          axios.post('/logout')
            .then(response => {
              context.commit('authLogout')
              localStorage.removeItem('access_token');
              resolve(response);
              delete axios.defaults.headers.common['Authorization'];
            })
            .catch(error => {
              console.log(error);
              localStorage.removeItem('access_token')
              context.commit('authError')
            })


        })
      }
    },
  },


  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
  }
})

export default store